import { Component, Output, EventEmitter, ViewEncapsulation, Input, OnInit, ViewChild } from "@angular/core";
import { SmartQueryInput } from "../common.data.types";
import { trim } from 'lodash';
import { ISmartSearchLayoutPreferences } from "../smart.search/smart.search.component";
import { QueryExpressionParserService } from "@nrwl/query-emitter";

@Component({
  selector: "smart-search-expert",
  templateUrl: "./expert.mode.component.html",
  styleUrls: ["./expert.mode.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class ExpertModeComponent implements OnInit {
  @Input() layoutPreferences:ISmartSearchLayoutPreferences;
  @Input() queryExpression:string;
  @Input() treatEmptyAsValid:boolean;
  @Output() inputChanged = new EventEmitter();

  expertQuery = "";

  constructor(private readonly queryEngine: QueryExpressionParserService) {
  }

  ngOnInit() {
    this.expertQuery = this.queryExpression;
  }

  updateQuery(query) {
    this.expertQuery = query;
    this.emitInputChanged();
  }

  emitInputChanged() {
    const query = trim(this.expertQuery);
    if (!query) {
      this.inputChanged.emit(new SmartQueryInput('', true, []));
      return;// empty input is fine
    }

    const valid = this.isExpressionValid(query);
    const parsedQuery = this.queryEngine.parseIntoTokens(query);
    // and last chance - check against business logic quirks
    let fitsWithConstraints = true;
    if (valid) {
      fitsWithConstraints = this.queryEngine.fitsWithUseCaseConstraints(parsedQuery);
    }
    this.inputChanged.emit(new SmartQueryInput(query, valid && fitsWithConstraints, parsedQuery));
  }

  isExpressionValid(expression: string) {
    if (this.treatEmptyAsValid) {
      const trimmedExp = trim(expression);
      if (trimmedExp.length === 0) {
        return true;
      }
    }
    // empty expression is not valid
    return this.queryEngine.isExpressionValid(expression);
  }
}
